<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'VFatherProAnamCAxAFSM',
  components: {},
};
</script>
